module.exports = __webpack_public_path__ + "static/winter-love_ceramic-sculpture-12hx14d-each-approx-eaaadbf7cf25338d5cb3857feb36dc41.jpg";